import gql from 'graphql-tag'
import {apolloClient, apolloClientOptionalAuth} from '@/plugins/apollo.js'
import {baseFieldNames, getProcessedResponseErrorsFlat, onSubmitHandler} from '@/scripts/forms-utils'
import {getQueries, logger} from '@/scripts/utils'
import router from '@/plugins/router'
import {setIntervalAsync} from 'set-interval-async/dynamic'
import {clearIntervalAsync} from 'set-interval-async'
import {store, resetStore} from '@/scripts/globals'
import {getTrainingParamsFromUrlPartOrArr} from "@/scripts/training-utils"


function setCredentials(accessToken, refreshToken) {
    localStorage.setItem('accessToken', accessToken)
    localStorage.setItem('refreshToken', refreshToken)

    if (process.env.VUE_APP_EXECUTON_ENV  === 'DEV') {
        document.cookie = `JWT=${accessToken ? accessToken : ''}; SameSite=Lax; max-age=86400`
    }
    else {
        document.cookie = `JWT=${accessToken ? accessToken : ''}; domain=${process.env.VUE_APP_PRODUCTION_DOMAIN}; SameSite=Lax; max-age=86400`
    }
}

async function setAccessToken(apolloClientForToken) {
    let refreshToken = localStorage.getItem('refreshToken')
    if (refreshToken === null)
        return false
    else
        try {
            let res = await apolloClientForToken.mutate(
                {
                    mutation: gql`
                        mutation {
                            refreshToken(refreshToken: ${JSON.stringify(refreshToken)}) {
                                success
                                errors
                                token
                                refreshToken
                            }
                        }
                    `
                })
            if (res.data['refreshToken'].success) {
                setCredentials(res.data['refreshToken'].token, res.data['refreshToken'].refreshToken)
                return true
            } else {
                return false
            }
        } catch (e) {
            console.log('Refreshing token error:', e)
            return false
        }
}


export function getLoginMutation(email, password) {
    return gql`
        mutation {
            obtainToken(email: ${JSON.stringify(email)}, password: ${JSON.stringify(password)}) {
                token
                success
                errors
                refreshToken
            }
        }
    `
}


export function getRegisterMutation(email, password1, password2, sender, signupTag) {
    let senderArg = sender ? `, senderToRegistrationUsername: ${JSON.stringify(sender)}`:  ''
    let signupTagArg = signupTag ? `, signupTag: ${JSON.stringify(signupTag)}`:  ''
    return gql`
        mutation {
            register(email: ${JSON.stringify(email)}, password1: ${JSON.stringify(password1)}, password2: ${JSON.stringify(password2)} ${senderArg} ${signupTagArg}) {
                success
                errors
            }
        }
    `
}

export async function verifyAccount(token) {
    const response = await apolloClient.mutate({
        mutation: gql`
                    mutation VerifyAccount($token: String!) {
                      verifyAccount(token: $token) {
                        success
                        errors
                        token
                        refreshToken
                      }
                    }
                `,
        variables: {
            token: token
        }
    });
    const data = response?.data?.verifyAccount;
    if (data?.success && data?.token && data?.refreshToken) {
        setCredentials(data?.token, data?.refreshToken);
    }
    return response;
}

export function getSetInitialUserInfoMutation(athleteFlag, coachFlag) {
    return gql`
        mutation {
            updateUser (updateUser: {athleteFlag: ${athleteFlag}, coachFlag: ${coachFlag}, baseInfoWasSet: true}) {
                user {
                    id
                }
                success
                errors
            }
        }
    `
}


export function getSendPasswordResetEmailMutation(email) {
    return gql`
        mutation {
            sendPasswordResetEmail(email: ${JSON.stringify(email)}){
                success,
                errors
            }
        }
    `
}


export function getResetPasswordMutation(token, newPassword1, newPassword2) {
    return gql`
        mutation {
            resetPassword (
                token: ${JSON.stringify(token)},
                newPassword1: ${JSON.stringify(newPassword1)},
                newPassword2: ${JSON.stringify(newPassword2)})
            {
                success
                errors
            }
        }
    `
}


export function getIsAuthenticatedQuery() {
    return gql`
        {
            isAuthenticated
        }
    `
}

export function getSimpleMyUserQuery() {
    return gql`
        {
            myUser {
                id
            }
        }
    `
}

const userQueryBody = `
                        id
                        email
                        username
                        isSuperuser  
                        updatedAt
                        fullName
                        clubName
                        country
                        crew1xFlag
                        crew2x2mFlag
                        crew4x4mFlag
                        crew8pFlag
                        coachFlag
                        athleteFlag
                        heightCm
                        weightKg
                        legLengthCm
                        wingspanCm
                        phone
                        gender     
                        birthDate   
                        baseInfoWasSet
                        hasMyTrainings 
                        lastViewedSrcTrainingsIds    
                        allowOnlineTrainingBetaAccess   
                        onlineTrainingDoDropoutOnWebsocketVideoClient
                        onlineTrainingHideSlowdownWarning
                        onlineTrainingHideOtherWarnings
                        onlineTrainingInvestorViewFlag
                        onlineTrainingElectronAppMode
                        onlineTrainingAllowTwoDeviceSetup
                        onlineTrainingEnableFullscreenRowing
                        onlineTrainingDoNotUseWebRtcForSingleDeviceMode
                        onlineTrainingSetDefaultSideToLeft
                        onlineTrainingHideDashboardBackground
                        onlineTrainingDoScreenPhotosExhibitionMode
                        onlineTrainingLastExhibitionScreenThumbnailsIds
                        permissions
                        subscriptions {
                            extId extCustomerId extProductId extPriceId startsAt endsAt status
                            group { id name }
                            analysisCount
                            amount
                            scheduledChange { action effectiveAt }
                        }
                        analysisCount
                        analysisLimit
                        announcement { text hash }
`

export const fetchUserQueries = getQueries('usersById', 'UserType',
    userQueryBody)

export function getMyUserQuery() {
    return gql`{
        myUser {
            ${fetchUserQueries.queryBody}
        }
    }`
}

export async function login(email, password) {
    let resp = await apolloClient.mutate(
        {mutation: getLoginMutation(email, password)}
    )
    console.log('login credentials', resp)
    setCredentials(resp.data['obtainToken'].token, resp.data['obtainToken'].refreshToken)
}

export async function refreshTokenOrRedirectToLogin(apolloClientForToken) {
    let tokenSetFlag = await setAccessToken(apolloClientForToken)
    if (!tokenSetFlag) {
        resetStore()
        await router.push({name: 'login', query: {next: location.pathname}})
    }
}

export async function refreshTokenOrFail(apolloClientForToken) {
    let tokenSetFlag = await setAccessToken(apolloClientForToken)
    if (!tokenSetFlag) {
        // noinspection UnnecessaryLocalVariableJS
        let error = new Error('Not authenticated notice')
        throw error
    }
}

export function isRefreshTokenSet() {
    const token = localStorage.getItem('refreshToken');
    return Boolean(token) && token !== 'null';
}

export async function logout() {
    setCredentials(null, null)
    resetStore()
    window.location.href = '/'
}

export function getNextUrl() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    // noinspection UnnecessaryLocalVariableJS
    const nextUrl = urlParams.get('next')
    return nextUrl
}

export function getTrainingSenderUsernameFromNext() {
    let nextUrl = getNextUrl()
    try {
        if (nextUrl) {
            let nextRoute = router.match(nextUrl)
            if (nextRoute.name === 'training' && nextRoute.params.trainingParams) {
                let trainingParams = getTrainingParamsFromUrlPartOrArr(nextRoute.params.trainingParams)
                if ('from' in trainingParams) {
                    return trainingParams['from']
                }
            }
        }
    }
    // eslint-disable-next-line no-empty
    catch {}
    return null
}

export function checkNextIsTraining() {
    let nextUrl = getNextUrl()
    if (nextUrl) {
        let nextRoute = router.match(nextUrl)
        // noinspection RedundantIfStatementJS
        if (nextRoute && nextRoute.name === 'training')
            return true
    }
    return false
}


export async function doRedirectToNextParamOrDefaultPage(defaultNextPageName) {
    let nextUrl = getNextUrl()
    await router.push(nextUrl ? nextUrl : {name: defaultNextPageName}).catch((err) => {}) //vue router API needs such catch
}

export async function onSubmitAuthHandler(componentScope, mutation, setErrorsF, defaultNextPageName) {
    await onSubmitHandler(componentScope, mutation, {
        async onSuccessF(res) {
            setCredentials(res['token'], res['refreshToken'])
            await doRedirectToNextParamOrDefaultPage(defaultNextPageName)
        },
        setErrorsF
    })
}

export async function onSubmitRegisterHandler(componentScope, mutation, onSuccessF, setErrorsF) {
    await onSubmitHandler(componentScope, mutation, {
        onSuccessF,
        setErrorsF
    })
}

const authFieldNames = {
    ...baseFieldNames,
    password: 'Password',
    email: 'Email',
    newPassword1: 'Password',
    newPassword2: 'Repeat password',
    oldPassword: 'Old password',
    password1: 'Password',
    password2: 'Repeat password',
    token: 'Link token',
    howFoundUs: 'How found us',
    name: 'Name',
    message: 'Message'
}


const authErrorMessages = {
    invalid_credentials: 'Wrong email or password',
    email_fail: 'Server error: failed to send email',
}


export function getProcessedAuthResponseErrorsFlat(rawResponseErrors) {
    return getProcessedResponseErrorsFlat(rawResponseErrors, authFieldNames, authErrorMessages)
}

export class AccessTokenUpdater {
    constructor() {
        this.updatePeriod = parseInt(process.env.VUE_APP_JWT_ACCESS_TOKEN_RENEW_MIN) * 60 * 1000
        this.intervalHandler = null
        this.started = false
    }

    async start() {
        if (this.started)
            throw Error('AccessTokenUpdater already have been started')
        let t = this
        this.intervalHandler = setIntervalAsync(async function () {
            await t._doUpdate()
        }, this.updatePeriod)
        this.started = true
    }

    async _doUpdate() {
        await refreshTokenOrRedirectToLogin(apolloClient)
        await logger.debug('Access token updated')
    }

    async stop() {
        if (this.started) {
            await clearIntervalAsync(this.intervalHandler)
            this.intervalHandler = null
            this.started = false
        }
    }
}


export async function fetchMyUser(checkIsSet, optionalAuthClient) {
    if (!(checkIsSet && store.myUser)) {
        let qRes = await (optionalAuthClient ? apolloClientOptionalAuth : apolloClient).query({
            query: getMyUserQuery()
        })
        store.myUser = qRes.data['myUser']
        return true
    }
    return false
}

export function hasPermission(permission, isReg = false) {
    const prefix = 'rowerup_api.';
    if (isReg) {
        let has = false;
        if (Array.isArray(store?.myUser?.permissions)) {
            store.myUser.permissions.forEach((userPermission) => {
                if (typeof permission?.test === 'function' && permission.test(userPermission)) {
                    has = true;
                }
            })
        }
        return has;
    } else {
        permission = prefix + permission;
        return store?.myUser?.permissions?.includes(permission) ?? false;
    }
}

export function getAnalysisLimit() {
    if (isSuperuser()) {
        return 0;
    }

    return store.myUser.analysisLimit
}

export function getAnalysisCount() {
    let analysisSubscription = getAnalysisActiveSubscription();
    return analysisSubscription ? analysisSubscription.analysisCount : Number(store.myUser.analysisCount)
}

export function isOverAnalysisLimit() {
    if (isSuperuser()) {
        return false;
    }

    const limit = getAnalysisLimit();
    const count = getAnalysisCount();
    return !(limit === 0 || count < limit);
}

function getAnalysisActiveSubscription() {
    let subscriptions = store?.myUser?.subscriptions;
    let analysisSubscription = null;

    if (Array.isArray(subscriptions)) {
        subscriptions.forEach((subscription) => {
            if (
                getAnalysisLimit() > 0
                && subscription.analysisCount < getAnalysisLimit()
                && !analysisSubscription
            ) {
                analysisSubscription = subscription;
            }
        });
    }

    return analysisSubscription;
}

function isSuperuser() {
    return !!store?.myUser?.isSuperuser;
}